// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__1NkzC","col":"Row_col__oO-BW","col1":"Row_col1__xL29Y","text":"Row_text__qjBfq","item":"Row_item__1qKQA","avatar":"Row_avatar__2zKZQ","user":"Row_user__MGrCx"};